import BidOfferSection from './BidOfferSection';

export default BidOfferSection;
